/** Tap tempo (F-PRAC-01): BPM from the median of recent tap intervals. */
import { MAX_BPM, MIN_BPM } from "../sequencer/time";

/** A pause longer than this starts a new tap sequence. */
export const TAP_RESET_MS = 2000;
export const TAP_WINDOW = 8;

/** Keep only the current tap sequence (drop taps before a long pause), at most TAP_WINDOW. */
export function addTap(taps: readonly number[], nowMs: number): number[] {
  const last = taps[taps.length - 1];
  const kept = last !== undefined && nowMs - last <= TAP_RESET_MS ? [...taps, nowMs] : [nowMs];
  return kept.slice(-TAP_WINDOW);
}

/** BPM from tap times (ms), or null with fewer than 3 taps. Median interval resists one sloppy tap. */
export function tapTempo(taps: readonly number[]): number | null {
  if (taps.length < 3) return null;
  const intervals = taps.slice(1).map((t, i) => t - taps[i]!).sort((a, b) => a - b);
  const mid = Math.floor(intervals.length / 2);
  const median = intervals.length % 2 ? intervals[mid]! : (intervals[mid - 1]! + intervals[mid]!) / 2;
  if (!(median > 0)) return null;
  return Math.min(MAX_BPM, Math.max(MIN_BPM, Math.round(60000 / median)));
}
